import React from "react";
import type { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { authentificated } from "@containers/Auth/store/selectors";
import { getUserDetails } from "@shared/store/selectors";
import { getDefaultUrl } from "@shared/utils";

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const isAuthenticated = useSelector(authentificated());
  const authenticatedUser = useSelector(getUserDetails());

  if (isAuthenticated && authenticatedUser) {
    return <Navigate to={getDefaultUrl(authenticatedUser)} />;
  }

  return <>{children}</>;
};

export default GuestGuard;
